<template lang="pug">
.step-cliente
  // RUT + Crear Nuevo Cliente
  .form-section
    b-row.align-items-end
      b-col(md="6")
        b-form-group(label="RUT" label-for="rut-autocomplete-ov" class="mb-0")
          RutAutocompleteOV(
            v-model="form.rut"
            :showValidation="$v.rut.$dirty && $v.rut.$error"
            @client-selected="onClientSelected"
            @create-new-client="onCreateNewClient"
            @client-cleared="onClientCleared"
            @empresa-detected="onEmpresaDetected"
            placeholder="Buscar cliente por RUT"
            hide-label
            class="mb-0"
          )
      b-col.align-self-center(md="6")
        b-button#btn-create-client.btn-create-client(@click="onCreateNewClient('')")
          | Crear Nuevo Cliente

  // Tipo de Cliente
  .form-section.mt-4
    label.form-label Tipo de Cliente
    .client-type-selector
      .type-option(:class="{ active: form.cliente_tipo === 'persona' }" @click="setClienteTipo('persona')")
        b-icon(icon="person-fill")
        span Persona
      .type-option(:class="{ active: form.cliente_tipo === 'retail' }" @click="setClienteTipo('retail')")
        b-icon(icon="shop")
        span Retail

  // Datos Cliente — Persona
  .form-section.mt-4(v-if="form.cliente_tipo === 'persona'")
    b-row
      b-col(md="6")
        b-form-group(label="Nombre" label-for="nombre")
          b-form-input#nombre(
            v-model="form.nombre"
            placeholder="Nombre del Cliente"
            :state="$v.nombre.$dirty ? !$v.nombre.$error : null"
          )
          b-form-invalid-feedback(v-if="!$v.nombre.required") El nombre es requerido
      b-col(md="6")
        b-form-group(label="Apellido" label-for="apellido")
          b-form-input#apellido(
            v-model="form.apellido"
            placeholder="Apellidos del Cliente"
          )

    b-row.mt-3
      b-col(md="6")
        b-form-group(label="Correo Electrónico" label-for="email")
          b-form-input#email(
            v-model="form.email"
            type="email"
            placeholder="Correo electrónico del Cliente"
            :state="$v.email.$dirty ? !$v.email.$error : null"
          )
          b-form-invalid-feedback(v-if="!$v.email.required") El correo es requerido
      b-col(md="6")
        b-form-group(label="Teléfono" label-for="telefono")
          b-form-input#telefono(
            v-model="form.telefono"
            placeholder="Contacto del Cliente"
            :state="$v.telefono.$dirty ? !$v.telefono.$error : null"
          )
          b-form-invalid-feedback(v-if="!$v.telefono.required") El teléfono es requerido

  // Datos Cliente — Retail (Empresa)
  .form-section.mt-4(v-else)
    b-row
      b-col(cols="12")
        b-form-group(label="Razón Social" label-for="razon-social")
          b-form-input#razon-social(
            v-model="form.nombre"
            placeholder="Razón Social de la Empresa"
            :state="$v.nombre.$dirty ? !$v.nombre.$error : null"
          )
          b-form-invalid-feedback(v-if="!$v.nombre.required") La razón social es requerida

    b-row.mt-3
      b-col(md="6")
        b-form-group(label="Correo Electrónico" label-for="email-retail")
          b-form-input#email-retail(
            v-model="form.email"
            type="email"
            placeholder="Correo electrónico de la Empresa"
            :state="$v.email.$dirty ? !$v.email.$error : null"
          )
          b-form-invalid-feedback(v-if="!$v.email.required") El correo es requerido
      b-col(md="6")
        b-form-group(label="Teléfono" label-for="telefono-retail")
          b-form-input#telefono-retail(
            v-model="form.telefono"
            placeholder="Teléfono de contacto"
          )

  // Datos Cliente — compartidos (Persona y Retail)
  .form-section.mt-4
    b-row
      b-col(md="6")
        b-form-group(label="Región" label-for="region")
          b-form-select#region(
            v-model="form.region"
            :options="regionOptions"
            :state="$v.region.$dirty ? !$v.region.$error : null"
          )
          b-form-invalid-feedback(v-if="!$v.region.required") La región es requerida
      b-col(md="6")
        b-form-group(label="Comuna" label-for="comuna")
          b-form-select#comuna(
            v-model="form.comuna"
            :options="comunaOptions"
            :disabled="!form.region"
            :state="$v.comuna.$dirty ? !$v.comuna.$error : null"
          )
          b-form-invalid-feedback(v-if="!$v.comuna.required") La comuna es requerida

    b-row.mt-3
      b-col(cols="12")
        b-form-group(label="Dirección" label-for="direccion")
          b-form-input#direccion(
            v-model="form.direccion"
            placeholder="Ingrese Calle y Número"
            :state="$v.direccion.$dirty ? !$v.direccion.$error : null"
          )
          b-form-invalid-feedback(v-if="!$v.direccion.required") La dirección es requerida

    b-row.mt-3
      b-col(cols="12")
        b-form-group(label="Persona de Contacto" label-for="contacto")
          b-form-input#contacto(
            v-model="form.contacto_nombre"
            placeholder="Ingrese Nombre de quien retira el equipo (Opcional)"
          )
</template>

<script>
import { mapActions } from 'vuex'
import RutAutocompleteOV from '../OV/stepFormOV/RutAutocompleteOV.vue'

export default {
  name: 'Step1Cliente',
  components: {
    RutAutocompleteOV,
  },
  props: {
    form: {
      type: Object,
      required: true,
    },
    $v: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      regiones: [],
      regionOptions: [],
    }
  },
  computed: {
    comunaOptions() {
      if (this.form.region) {
        const region = this.regiones.find((r) => r.region === this.form.region)
        if (region && region.comunas) {
          return [
            { value: null, text: 'Seleccione' },
            ...region.comunas
              .map((c) => ({ value: c, text: c }))
              .sort((a, b) => a.text.localeCompare(b.text)),
          ]
        }
      }
      return [{ value: null, text: 'Seleccione' }]
    },
  },
  methods: {
    ...mapActions('ClientStore', ['listRegiones']),
    ...mapActions('OVStore', ['getEmpresaDatosPrellenado']),

    // Selector manual "Persona"/"Retail": una empresa no tiene apellido, así
    // que se limpia al cambiar de tipo para no arrastrar un valor viejo de
    // cuando el formulario estaba en modo Persona.
    setClienteTipo(tipo) {
      this.form.cliente_tipo = tipo
      if (tipo === 'retail') {
        this.form.apellido = ''
      }
    },

    onClientSelected(clientData) {
      this.form.cliente_tipo = 'persona'
      this.form.id = clientData.id
      this.form.nombre = clientData.nombre
      this.form.apellido = clientData.apellido
      this.form.email = clientData.correo
      this.form.telefono = clientData.telefono
      this.form.region = clientData.region
      this.form.comuna = clientData.comuna
      this.form.direccion = clientData.calle

      this.$bvToast.toast('Datos del cliente cargados', {
        variant: 'success',
        autoHideDelay: 2000,
      })
    },

    // El RutAutocompleteOV detectó que el RUT ingresado corresponde a una
    // empresa: cambia el formulario a la sección Retail (Razón Social en vez
    // de Nombre/Apellido) y prellena los datos reusando el mismo endpoint
    // que usa OV para empresas.
    async onEmpresaDetected(empresa) {
      this.form.cliente_tipo = 'retail'
      this.form.id = empresa.id

      try {
        const data = await this.getEmpresaDatosPrellenado(empresa.id)
        this.form.nombre = data.razon_social || empresa.razon_social || ''
        this.form.apellido = ''
        this.form.email = data.email || ''
        this.form.telefono = data.telefono || ''
        this.form.region = data.region || ''
        this.form.comuna = data.comuna_nombre || data.comuna || ''
        this.form.direccion = data.direccion || ''

        this.$bvToast.toast('Datos de la empresa cargados', {
          variant: 'success',
          autoHideDelay: 2000,
        })
      } catch (error) {
        console.error('Error al cargar datos de empresa:', error)
        this.$bvToast.toast('Error al cargar los datos de la empresa', {
          variant: 'danger',
          autoHideDelay: 3000,
        })
      }
    },

    onCreateNewClient(rut) {
      if (rut) this.form.rut = rut
      // Aquí podrías abrir un modal o simplemente permitir edición manual
      this.$bvToast.toast('Puede ingresar los datos del nuevo cliente', {
        variant: 'info',
        autoHideDelay: 2000,
      })
    },

    onClientCleared() {
      this.form.id = null
      this.form.nombre = ''
      this.form.apellido = ''
      this.form.email = ''
      this.form.telefono = ''
      this.form.region = null
      this.form.comuna = null
      this.form.direccion = ''
    },
  },
  async mounted() {
    try {
      const res = await this.listRegiones()
      this.regiones = res
      this.regionOptions = [
        { value: null, text: 'Seleccione' },
        ...res.map((r) => ({ value: r.region, text: r.region })),
      ]
    } catch (error) {
      console.error('Error loading regions:', error)
    }
  },
}
</script>

<style lang="scss" scoped>
@import '@/style/colors.scss';

.step-cliente {
  .form-label {
    font-weight: bold;
    color: #23201c;
    font-size: 15px;
    margin-bottom: 8px;
    display: block;
  }

  .client-type-selector {
    display: flex;
    gap: 20px;

    .type-option {
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding: 12px;
      border: 1px solid #525252;
      border-radius: 8px;
      cursor: pointer;
      background-color: rgba(82, 82, 82, 0.05);
      transition: all 0.2s ease;

      .b-icon {
        font-size: 24px;
        margin-bottom: 8px;
        color: #525252;
      }

      span {
        color: #525252;
        font-size: 15px;
      }

      &.active {
        background-color: rgba(254, 206, 47, 0.3);
        border-color: #fece2f;

        .b-icon,
        span {
          color: #23201c;
        }
      }
    }
  }

  .btn-create-client {
    background-color: #f5f6fa;
    border-radius: 8px;
    border: none;
    height: 45px;
    font-weight: 500;
    color: #23201c;

    &:hover {
      background-color: #ebecf2;
    }
  }

  ::v-deep .form-group label {
    font-weight: bold;
    color: #23201c;
    font-size: 15px;
  }

  ::v-deep .form-control,
  ::v-deep .custom-select {
    height: 45px;
    border: 1px solid #525252;
    border-radius: 5px;
    font-size: 15px;

    &::placeholder {
      color: #525252;
    }
  }
}
</style>
